import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';

import {Setting} from '../../core/setting';

import styles from './form-flash-banner.module.css';

export function FormFlashBanner() {
    const [showBanner, setShowBanner] = React.useState<boolean>(
        NutClientConfig.shouldShowFormBanner && !NutClientConfig.isTrial
    );

    return (
        <Setting settingName='hide_form_banner'>
            {/* @ts-expect-error */}
            {({updateSetting}) => {
                if (showBanner) {
                    return (
                        <FlashBanner
                            type='info'
                            hasBorder={true}
                            onHidden={() => {
                                setShowBanner(false);
                                updateSetting('1');
                            }}
                        >
                            <div className='full-width flex'>
                                <div>
                                    Build a Nutshell form to automatically create leads from your
                                    website!
                                </div>
                                <div className={styles['flash-banner-cta-container']}>
                                    <Link variant='primary' href='/email-marketing/forms'>
                                        Check it out
                                    </Link>
                                </div>
                            </div>
                        </FlashBanner>
                    );
                }

                return null;
            }}
        </Setting>
    );
}
